import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as actions from '../../actions';

/**
 * ResumeAuthSession Component
 */
export class ResumeAuthSession extends Component {

  static propTypes = {
    startResumeAuthSession: PropTypes.func.isRequired,
    sessionService: PropTypes.string,
    stateToken: PropTypes.string,
  };

  componentDidMount() {
    if (this.props.sessionService && this.props.stateToken) {
      setTimeout( () => this.props.startResumeAuthSession(), 100);
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => {
  const { stateToken, sessionService, } = state.login;
  return { stateToken, sessionService, };
};

const mapDispatchToProps = dispatch => {
  return {
    startResumeAuthSession: () => {
      dispatch(actions.startResumeAuthSession() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResumeAuthSession);
